import { useMemo } from 'react';
import { TouchableOpacity, useWindowDimensions } from 'react-native';

import { Ionicons } from '@expo/vector-icons';
import { Box, Divider, HStack, Icon, VStack } from '@gluestack-ui/themed';
import { DrawerActions, Link, useNavigation } from '@react-navigation/native';

import { firebaseApp } from '../../services/firebase/firebaseFactory';
import { Images } from '../../themes';
import imagesUrl from '../../themes/imagesUrl';
import { screenBreakPoint } from '../../util/device-utils';
import { resizedImage } from '../../util/image-utils';
import Image from '../image/image';

function HeaderWebOwner() {
  const { width } = useWindowDimensions();
  const navigation = useNavigation();

  const display = useMemo(
    () =>
      screenBreakPoint(width, [
        { brand: false, logo: false, search: true, profile: false },
        { brand: false, logo: false, search: true, profile: false },
        { brand: true, logo: false, search: true, profile: true },
        { brand: true, logo: false, search: true, profile: true },
        { brand: true, logo: false, search: true, profile: true },
      ]),
    [width],
  );

  return (
    <VStack w={'100%'}>
      <VStack mx={'$screenMargin'} w={'100%'} alignSelf={'center'}>
        <HStack py={'$2'} alignItems={'center'} justifyContent={'space-between'} mx={'$4'} space={'md'}>
          {display?.brand && (
            <Link to={{ screen: 'Search' }}>
              <Image source={{ uri: imagesUrl.brandNameDark }} h={51} w={119} resizeMode={'contain'} />
            </Link>
          )}
          {display?.logo && (
            <Link to={{ screen: 'Search' }}>
              <Image source={{ uri: imagesUrl.logo }} h={51} w={51} resizeMode={'contain'} />
            </Link>
          )}
          {display?.profile && (
            <Box
              variant={'cardContainer'}
              rounded={'$full'}
              px={'$4'}
              py={'$2'}
              alignItems={'center'}
              justifyContent={'center'}
              alignSelf={'center'}>
              <TouchableOpacity onPress={() => navigation.dispatch(DrawerActions.openDrawer())}>
                <HStack alignItems={'center'} space={'sm'}>
                  <Icon as={Ionicons} name={'menu-outline'} color={'$black'} size={'xl'} />
                  <Image
                    source={{
                      uri: resizedImage(firebaseApp.auth()?.currentUser?.photoURL ?? 'https://assets.flyandcar.com/assets/default-pp.png'),
                    }}
                    h={35}
                    w={35}
                    rounded={'$full'}
                  />
                </HStack>
              </TouchableOpacity>
            </Box>
          )}
        </HStack>
      </VStack>
      <Divider bg={'$light100'} />
    </VStack>
  );
}

export default HeaderWebOwner;
